export default {
    address: 'Email Address',
    familyName: 'Last Name',
    givenName: 'First Name',
    info: {
        editingTeamNameNotAutomaticallyChange:
            "Editing a Team Member's name will not automatically change their name on previously created Documents.",
        goToYourEmailSettings:
            'Email address settings can be found in <0>email settings</0>.',
        note: 'Note:',
        noteThatEditing:
            "Note that editing this team member's name will not change the sender's contact information in previously created documents.",
        notificationsAboutEvents:
            'Notifications about events in <0>{{company}}</0> will be sent to <0>{{email}}.</0>',
    },
    sendingSignature: 'Sender Signature',
    submit: 'Save Team Member',
};
